// Invitation system constants

export const MAX_INVITES = 150;
export const INVITE_PATH = '/invite';
